import React from "react";
import "./newlaunch.scss";
import gambarPromo from "./arunagriya.jpeg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";

const newlaunch = () => {
  const waOpen = () => {
    window.open(
      "https://api.whatsapp.com/send?phone=6281188016089&text=Halo%20Wasen%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20rumah%20ini%20(Arunagriya)%20(https://www.podomoropark-bdg.com/)%20?&fbclid=PAAaa7g9IJ-tB3RyMunLD6w_5ysqP4oI6PA2d9Ml7Isc1_OXjeOiGuAqu7Ap0",
      "_blank",
    );
  };
  return (
    <div className="newlaunc" id="newlaunch">
      <div id="newpromo" className="container-produkmtr">
        <div className="header">
          <div className="h2">
            New Launching <br />
            Cluster Arunagriya
          </div>
        </div>
        <div className="container-promo-terbaru">
          <div className="gambar-promo">
            <img src={gambarPromo} alt="promo-discover" />
          </div>
          <div className="container-listpromo-terbaru">
            <div className="listpromo">
              <ul className="list">
                <li>
                  <FontAwesomeIcon icon={faCheckCircle} color="#25974d" />
                  &nbsp;&nbsp;Free Smarthome System&nbsp;
                </li>
                <li>
                  <FontAwesomeIcon icon={faCheckCircle} color="#25974d" />
                  &nbsp;&nbsp;Free Canopy&nbsp;
                </li>
                <li>
                  <FontAwesomeIcon icon={faCheckCircle} color="#25974d" />
                  &nbsp;&nbsp;Garansi 1th&nbsp;
                </li>
                <li>
                  <FontAwesomeIcon icon={faCheckCircle} color="#25974d" />
                  &nbsp;&nbsp;Free lifetime membership clubhouse&nbsp;
                </li>
              </ul>
            </div>
            <div className="disclaimer">T&C Apply*</div>
            <button onClick={waOpen} className="btn-navbar">
              <FontAwesomeIcon icon={faWhatsapp} /> &nbsp; Learn More
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default newlaunch;
